import {
  ComponentDefinitionLegacyTypeDto,
  DiscriminatorTypeDto,
  UnitMeasurementDto,
} from '@/api/generated';
import { unitMeasurementOptionsTranslation } from '@/assets/locales/utils/dictionaries/dictionaries.translation.pl.ts';
import { ComponentDefinitionDetailsPricesConditionalAddFormModel } from '@/views/componentDefinitions/details/components/pricesList/components/conditionalPrices/components/add/model/ComponentDefinitionDetailsPricesConditionalAddForm.model.ts';
import { ComponentDefinitionDetailsPricesListConditionalAddContainerDialogFormModel } from '@/views/componentDefinitions/details/components/pricesList/components/conditionalPrices/components/addContainerDialog/model/ComponentDefinitionDetailsPricesListConditionalAddContainerDialogForm.model.ts';

export type ComponentDefinitionTypeOptions = Record<ComponentDefinitionLegacyTypeDto, string>;
export type ComponentDefinitionUnitMeasurementOptions = Record<UnitMeasurementDto, string>;
export type DiscriminatorTypeOptions = Record<DiscriminatorTypeDto, string>;
export type OfferElementTypeOptions = ComponentDefinitionTypeOptions;

export const componentDefinitionTypeOptions: ComponentDefinitionTypeOptions = {
  [ComponentDefinitionLegacyTypeDto.BeveragePackages]: 'Zestawy napojów',
  [ComponentDefinitionLegacyTypeDto.CateringPackages]: 'Pakiety cateringowe',
  [ComponentDefinitionLegacyTypeDto.Decoration]: 'Dekoracje',
  [ComponentDefinitionLegacyTypeDto.Equipment]: 'Sprzęt',
  [ComponentDefinitionLegacyTypeDto.Product]: 'Produkt',
  [ComponentDefinitionLegacyTypeDto.Room]: 'Sala',
  [ComponentDefinitionLegacyTypeDto.Service]: 'Obsługa',
  [ComponentDefinitionLegacyTypeDto.Staffing]: 'Personel',
  [ComponentDefinitionLegacyTypeDto.Transport]: 'Transport',
};
export const offerElementTypeOptions = componentDefinitionTypeOptions;

export const componentDefinitionDiscriminatorTypeOptions: DiscriminatorTypeOptions = {
  [DiscriminatorTypeDto.WithBasicPrice]: 'Cena stała',
  [DiscriminatorTypeDto.WithConditionalPrices]: 'Ceny warunkowe',
};

export const componentDefinitionDiscriminatorTypeDescriptions: DiscriminatorTypeOptions = {
  [DiscriminatorTypeDto.WithBasicPrice]:
    'Definicja komponentu z prostą listą cen obowiązujących w czasie.',
  [DiscriminatorTypeDto.WithConditionalPrices]:
    'Definicja komponentu z progami ilościowymi i opcjonalną ceną za nadmiarową jednostkę.',
};

export type FormConditionalContainerType = Record<
  keyof ComponentDefinitionDetailsPricesListConditionalAddContainerDialogFormModel,
  string
>;
export const formConditionalContainer: FormConditionalContainerType = {
  oversizeOrderUnitPrice: 'Cena za dodatkow(ą/y)',
  validFrom: 'Ważna od',
  validTo: 'Ważna do',
};

export type ComponentDefinitionMainDetails = {
  active: string;
  name: string;
  type: string;
  typeOptions: ComponentDefinitionTypeOptions;
  unit: string;
  unitOptions: ComponentDefinitionUnitMeasurementOptions;
};

export const componentDefinitionMainDetails: ComponentDefinitionMainDetails = {
  active: 'Aktywny',
  name: 'Nazwa',
  type: 'Typ',
  typeOptions: componentDefinitionTypeOptions,
  unit: 'Jednostka',
  unitOptions: unitMeasurementOptionsTranslation,
};

export type ComponentDefinitionFormConditionalType = Record<
  keyof ComponentDefinitionDetailsPricesConditionalAddFormModel,
  string
>;
export const componentDefinitionFormConditional: ComponentDefinitionFormConditionalType = {
  comment: 'Wskazówki do obliczeń',
  manuallyCalculatedPrice: 'Cena wyliczana przez sprzedawcę',
  minimumPrice: 'Cena minimalna',
  upToQuantity: 'Do liczby jednostek',
};
